module.exports = __webpack_public_path__ + "static/media/nashville_team.b5555401.jpg";